import { ManageTopics } from "@/shared/components/visualization/PanelSettings/ImagePanelSettings/ManageTopics.tsx";
import { type ImagePanelState } from "@/shared/state/visualization";

import { type PanelSettingsSidebarProps } from "../../sidebarContext";
import { BasePanelSettings } from "../BasePanelSettings";
import { SettingsSection } from "../SettingsSection";
import styles from "../SettingsSection.module.css";
import { Spotlight } from "../Spotlight";

import { AddImageTopic } from "./AddImageTopic";
import { RotateImage } from "./RotateImage";
import { StretchImageToFit } from "./StretchImageToFit";

export interface ImagePanelSettingsSidebarProps extends PanelSettingsSidebarProps {
  field?: "Clips";
}

interface ImagePanelSettingsProps extends ImagePanelSettingsSidebarProps {
  state: ImagePanelState;
}

export function ImagePanelSettings({
  field,
  spotlightKey,
  state,
}: ImagePanelSettingsProps) {
  return (
    <BasePanelSettings state={state}>
      <SettingsSection title="Image transforms">
        <StretchImageToFit
          panelId={state.id}
          stretchImageToFit={state.config?.stretchToFitCanvas ?? false}
        />
        <RotateImage
          panelId={state.id}
          rotation={state.config?.rotation ?? 0}
        />
      </SettingsSection>
      <SettingsSection title="Clips">
        <ManageTopics panelId={state.id} clips={state.data ?? []} />
        <Spotlight
          className={styles.settingContainer}
          spotlightKey={field === "Clips" ? spotlightKey : undefined}
        >
          <AddImageTopic state={state} />
        </Spotlight>
      </SettingsSection>
    </BasePanelSettings>
  );
}
